import React from 'react';
import { Divider, Grid, makeStyles, SvgIcon, Tab, Tabs } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import LogoGSE from '../assets/img/Logo_gse.png';
import { Label } from '@material-ui/icons';
import { cleanFiles, resetCF, stepCircuit } from '../redux/actions/CircuitoFirmasAction';
 
const useStyles = makeStyles((theme) => ({
    divider: {
        height: '1px',
        background: '#C1C1C1 0% 0% no-repeat padding-box',
    },
    icon: {
        position: 'relative',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        width: '19px',
        height: '19px',
    },
    tabs: {
        flexGrow: 2,
        marginLeft: '30px',
    },
    text:{
        color:'#a7a7a7',
        width: '133px',
        height: '20px',
        fontSize: '15px',
        lineHeight: '22px',
        letterSpacing: '0.3px',
        position: 'relative',
        left: '10%',
        /*fontSize:'80%',
        
        
        height: '15px',
        transform: 'translate(0%,25%)',
        fontFamily: "Arial",*/
        
    },
    logo: {
        position: 'relative',
        left: '10%',
        filter: 'brightness(0.5)',
	},

}));

const docsIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M10.721,16.366H2A1.989,1.989,0,0,1,.006,14.548H8.9a2,2,0,0,0,2-2V.182c0-.058,0-.116-.008-.174A2.012,2.012,0,0,1,12.721,2V14.366A2,2,0,0,1,10.721,16.366Z" transform="translate(3.64 4.636)" /><path class="a" d="M10.724,16.365H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0h8.723a2,2,0,0,1,2,2V14.365A2,2,0,0,1,10.724,16.365Zm-6.857-4.95a.909.909,0,0,0,0,1.818H9.32a.909.909,0,0,0,0-1.818Zm0-4.142a.909.909,0,0,0,0,1.818H9.32a.909.909,0,0,0,0-1.818Zm0-4.142a.909.909,0,0,0,0,1.818H9.32a.909.909,0,0,0,0-1.818Z" />
        </SvgIcon>
    );
}

const checkIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M10.394,20H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0H13a2,2,0,0,1,2,2V8.342a2.044,2.044,0,0,0-.235.327L12.266,13l-.865-.5a2,2,0,0,0-2.731.733l-1.5,2.6A2,2,0,0,0,7.9,18.559L10.4,20l0,0ZM3,13a1,1,0,0,0,1,1H6a1,1,0,0,0,0-2H4A1,1,0,0,0,3,13ZM3,9a1,1,0,0,0,1,1h7a1,1,0,1,0,0-2H4A1,1,0,0,0,3,9ZM3,5A1,1,0,0,0,4,6h7a1,1,0,0,0,0-2H4A1,1,0,0,0,3,5ZM13.23,19.326l-3.462-2A1,1,0,0,1,9.4,15.961l.5-.865a1,1,0,0,1,1.366-.365l1.731,1,3-5.195a1,1,0,0,1,1.365-.366l.866.5a1,1,0,0,1,.366,1.366L15.1,18.1l-.5.865a1,1,0,0,1-1.366.365Z" />
        </SvgIcon>
    );
}

const iconEncrypt = (props) => {
	return (
        <SvgIcon {...props}>
            <g stroke="null" id="svg_1" transform="translate(0 80) scale(0.1 -0.1)">
                <path stroke="null" id="svg_2" d="m33.54428,789.7703c-6.94254,-3.38108 -13.88509,-10.14324 -17.50728,-16.90541c-5.73514,-10.425 -6.03699,-16.34189 -6.03699,-90.16218c0,-73.82028 0.30185,-79.73717 6.03699,-90.16218c10.86659,-19.72298 21.12948,-22.54054 84.51791,-22.54054c63.69028,0 73.65132,2.81757 84.51791,22.54054c5.73514,10.425 6.03699,15.77838 5.43329,69.59393l-0.90555,58.60541l-33.80716,1.40878c-21.73318,0.84527 -35.31641,2.81757 -37.73121,5.07162c-2.4148,2.25405 -4.52775,14.93311 -5.43329,35.2196l-1.50925,31.55676l-10.56474,0c-9.35734,0 -10.56474,-0.84527 -11.47029,-7.60743c-0.90555,-6.76216 -2.4148,-7.88919 -9.96104,-7.88919c-6.64069,0 -8.75364,-1.40878 -8.75364,-5.63514c0,-4.50811 -2.11295,-5.63514 -9.05549,-5.63514c-8.14994,0 -9.05549,0.84527 -9.05549,8.4527c0,7.60743 0.90555,8.4527 9.35734,8.4527c7.24439,0 9.05549,1.12703 8.14994,5.07162c-1.50925,7.04392 -22.33688,7.60743 -36.22196,0.56351zm54.93664,-30.99325c0,-7.60743 -0.90555,-8.4527 -9.05549,-8.4527c-6.94254,0 -9.05549,-1.12703 -9.05549,-5.63514c0,-4.50811 2.11295,-5.63514 9.05549,-5.63514c8.14994,0 9.05549,-0.84527 9.05549,-8.4527c0,-7.60743 -0.90555,-8.4527 -9.05549,-8.4527c-6.94254,0 -9.05549,-1.12703 -9.05549,-5.63514c0,-4.50811 2.11295,-5.63514 9.05549,-5.63514c8.14994,0 9.05549,-0.84527 9.05549,-8.4527c0,-7.60743 -0.90555,-8.4527 -9.35734,-8.4527c-7.24439,0 -9.05549,-1.12703 -8.14994,-4.78987c0.6037,-3.09932 4.2259,-5.35338 9.05549,-5.91689c8.75364,-0.84527 10.56474,-6.48041 13.28139,-40.00947c2.11295,-24.23108 -3.6222,-32.40203 -22.94058,-32.40203c-19.31838,0 -25.05352,8.17095 -22.94058,32.40203c5.73514,61.42298 4.52775,56.35136 14.18694,56.35136c6.64069,0 8.75364,1.40878 8.75364,5.63514c0,4.50811 -2.11295,5.63514 -9.05549,5.63514c-8.14994,0 -9.05549,0.84527 -9.05549,8.4527c0,7.60743 0.90555,8.4527 9.05549,8.4527c6.94254,0 9.05549,1.12703 9.05549,5.63514c0,4.50811 -2.11295,5.63514 -9.05549,5.63514c-8.14994,0 -9.05549,0.84527 -9.05549,8.4527c0,7.60743 0.90555,8.4527 9.05549,8.4527c6.94254,0 9.05549,1.12703 9.05549,5.63514c0,4.50811 2.11295,5.63514 9.05549,5.63514c8.14994,0 9.05549,-0.84527 9.05549,-8.4527z"/>
                <path stroke="null" id="svg_3" d="m131.34357,766.66625l0.90555,-26.20338l28.07202,-0.84527c21.43133,-0.56351 27.77017,0 27.77017,2.81757c0,4.78987 -48.5978,50.15271 -53.72924,50.15271c-3.0185,0 -3.6222,-6.48041 -3.0185,-25.92163z"/>
            </g>
        </SvgIcon>
    );
}

const iconDecrypt = (props) => {
	return (
        <SvgIcon style={{ width: '22px' }} {...props}>
            <g stroke="null" id="svg_1" transform="translate(0 206) scale(0.1 -0.1)">
                <path stroke="null" id="svg_2" d="m18.42158,2049.48731c-1.3385,-1.31502 -2.19028,-2.86914 -2.0686,-3.58642c0.24336,-0.83683 0.12168,-1.07593 -0.36505,-0.59774c-0.48673,0.47819 -2.79869,-0.95638 -5.11065,-2.98868c-2.43364,-2.15185 -4.98897,-3.58642 -5.71906,-3.46687c-0.73009,0.23909 -0.97346,0.11955 -0.48673,-0.35864c0.73009,-0.83683 0.12168,-1.79321 -3.52878,-5.85782c-2.19028,-2.39095 -2.19028,-191.39532 0,-193.78627c3.16374,-3.58642 3.89383,-4.90144 4.25888,-7.65103c0.60841,-3.70597 2.67701,-5.73827 6.44915,-6.33601c2.79869,-0.35864 4.13719,-1.07593 7.66598,-4.18416c1.21682,-1.07593 18.49569,-1.43457 66.80351,-1.55412l65.22164,-0.11955l6.08411,3.10823c3.4071,1.67366 6.69252,2.98868 7.42261,2.98868c2.19028,0 4.62392,2.98868 5.11065,6.09692c0.36505,2.74959 1.09514,4.06461 4.25888,7.53148c1.09514,1.31502 1.46019,17.9321 1.58187,69.45701c0,61.80598 -0.12168,68.14199 -1.94691,70.1743c-1.94691,1.91276 -4.25888,2.15185 -26.77008,2.15185c-26.52671,0 -33.58428,1.19547 -35.16615,6.09692c-0.48673,1.19547 -1.09514,2.2714 -1.58187,2.2714c-0.48673,0 -0.97346,1.67366 -1.09514,3.82552c-0.24336,2.39095 -1.46019,4.78189 -3.52878,6.5751c-1.82523,1.55412 -2.67701,2.74959 -1.94691,2.74959c0.97346,0 1.09514,0.83683 0.24336,3.10823c-0.73009,1.67366 -1.21682,4.90144 -1.21682,7.17284l0,4.18416l-8.76112,-0.35864c-4.7456,-0.23909 -8.8828,-0.95638 -9.12616,-1.55412c-0.24336,-0.71728 2.31196,-3.94506 5.4757,-7.17284c6.69252,-6.69465 7.17925,-8.00967 3.65046,-9.32469c-1.3385,-0.47819 -2.67701,-1.91276 -3.04205,-3.22778c-0.48673,-1.79321 -1.82523,-2.39095 -6.20579,-2.63004c-6.57084,-0.47819 -7.30093,-1.67366 -3.65046,-5.73827c1.94691,-2.15185 2.92037,-4.78189 3.16374,-9.20515c0.48673,-6.45556 -0.60841,-7.89013 -6.44915,-8.8465c-5.23233,-0.95638 -5.35402,-2.74959 -0.73009,-7.29239c6.93588,-6.8142 6.93588,-6.8142 7.30093,-19.36667c0.24336,-6.8142 0.97346,-12.55247 1.70355,-13.3893c0.85178,-0.83683 2.0686,-2.2714 2.79869,-3.22778c0.85178,-0.95638 1.46019,-6.45556 1.46019,-13.3893c0,-7.05329 -0.60841,-12.43293 -1.46019,-13.3893c-3.4071,-3.82552 -3.89383,-4.66235 -3.4071,-6.21646c0.36505,-0.95638 0,-1.31502 -0.60841,-0.95638c-0.73009,0.47819 -2.55533,-0.23909 -4.13719,-1.55412c-4.86729,-3.82552 -5.23233,-4.18416 -6.8142,-4.3037c-0.85178,-0.11955 -2.67701,-0.23909 -4.13719,-0.35864c-1.46019,0 -2.79869,-1.19547 -3.16374,-2.51049c-0.73009,-2.63004 -4.13719,-2.39095 -7.78766,0.71728c-0.97346,0.83683 -3.16374,1.79321 -4.86729,1.91276c-3.4071,0.35864 -4.62392,1.19547 -10.58635,7.17284c-6.8142,6.8142 -6.93588,7.05329 -7.30093,14.10659c-0.36505,6.45556 1.94691,14.46523 4.62392,16.13889c0.60841,0.35864 1.21682,5.26008 1.21682,10.63971c0,9.68334 1.94691,17.45391 4.86729,19.24712c2.19028,1.31502 1.3385,7.05329 -1.46019,10.16153c-5.11065,5.49918 -3.89383,11.95474 2.31196,11.95474c1.58187,0 3.65046,0.71728 4.50224,1.55412c2.43364,2.2714 -0.12168,3.82552 -7.05757,4.3037c-7.78766,0.47819 -9.61289,2.2714 -9.00448,9.44424c0.36505,6.09692 1.94691,8.60741 5.4757,8.60741c1.21682,0 3.16374,0.71728 4.25888,1.55412c1.82523,1.43457 1.82523,1.67366 -0.36505,2.98868c-1.21682,0.83683 -4.62392,1.43457 -7.66598,1.43457c-6.8142,0 -8.39607,1.91276 -7.78766,9.20515c0.36505,5.61873 1.94691,8.72696 4.50224,8.72696c0.73009,0 1.21682,0.71728 0.97346,1.43457c-0.48673,2.74959 -2.92037,4.42325 -7.05757,4.78189l-4.13719,0.35864l0,7.17284c-0.12168,5.85782 0.48673,7.77058 2.67701,10.16153c1.58187,1.67366 2.67701,3.46687 2.43364,4.18416c-0.73009,2.15185 -8.76112,1.43457 -11.19476,-0.95638z"/>
                <path stroke="null" id="svg_3" d="m128.66562,2050.68278c-1.94691,-1.91276 -1.82523,-42.9175 0.12168,-44.83026c0.97346,-0.95638 7.78766,-1.43457 22.87625,-1.43457c13.99345,0 21.90279,-0.47819 22.75456,-1.31502c0.97346,-0.95638 1.3385,-0.59774 1.21682,1.43457c-0.36505,3.94506 -45.14408,47.93849 -46.96932,46.14528z"/>
                <path stroke="null" id="svg_4" d="m58.33333,1916.31155c-4.98897,-5.73827 -4.98897,-9.32469 0,-14.94342c5.11065,-5.73827 9.36953,-5.73827 15.45364,0.23909c5.59738,5.49918 5.4757,8.96605 -0.12168,14.34568c-6.32747,5.97737 -10.46467,5.97737 -15.33195,0.35864z"/>
            </g>
        </SvgIcon>
    );
}

const plumaIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M5.069,5.15A2.375,2.375,0,0,0,3.462,6.685L0,17.07l.545.545,5.57-5.57a1.8,1.8,0,1,1,.839.839l-5.57,5.57L1.93,19l10.385-3.462a2.375,2.375,0,0,0,1.534-1.607l1.588-5.618-4.75-4.75Zm13.409-2.4L16.248.522a1.782,1.782,0,0,0-2.52,0l-2.1,2.1L16.38,7.371l2.1-2.1a1.782,1.782,0,0,0,0-2.52Z" />
        </SvgIcon>
    );
}
const circuitoFirmas = (props) => {
    return (
        <SvgIcon {...props}>
            <path d="M10.0449 23.1377C9.98963 23.1118 9.93931 23.0746 9.89844 23.0293C9.85756 22.984 9.82667 22.9307 9.80664 22.873L8.75586 19.8232C8.7178 19.7063 8.72785 19.5795 8.7832 19.4697C8.80935 19.4153 8.84526 19.366 8.89062 19.3262C8.93599 19.2863 8.98953 19.2562 9.04688 19.2373L12.0918 18.1865C12.1494 18.1662 12.2106 18.1576 12.2715 18.1621C12.3324 18.1666 12.3913 18.1844 12.4453 18.2129C12.5006 18.2367 12.5498 18.2715 12.5898 18.3164C12.6299 18.3613 12.6603 18.415 12.6777 18.4727C12.6991 18.529 12.7087 18.5893 12.7051 18.6494C12.7015 18.7096 12.6842 18.7679 12.6562 18.8213L12.0449 20.0781C12.4677 20.265 12.9211 20.3728 13.3828 20.3955C13.9276 20.4219 14.4698 20.3255 14.9727 20.1143C15.4755 19.903 15.9246 19.5824 16.2871 19.1748C16.708 18.7059 17.0012 18.1353 17.1348 17.5195C17.1825 17.2145 17.2124 16.9071 17.2246 16.5986C17.2196 16.5496 17.2313 16.5005 17.2578 16.459C17.2843 16.4174 17.3226 16.3853 17.3691 16.3691L18.6777 15.9189C18.7372 15.9005 18.8012 15.9049 18.8574 15.9316C18.8846 15.944 18.9079 15.962 18.9277 15.9844C18.9475 16.0068 18.9637 16.033 18.9727 16.0615C18.9819 16.0779 18.9852 16.0966 18.9824 16.1152C19.1264 17.3661 18.8423 18.6289 18.1758 19.6973C17.5224 20.7668 16.507 21.5667 15.3145 21.9521C13.9789 22.4113 12.5174 22.3357 11.2363 21.7412L10.6582 22.9229C10.6217 23.0005 10.5643 23.0658 10.4922 23.1123C10.42 23.1588 10.3358 23.1843 10.25 23.1855C10.1789 23.185 10.1088 23.1688 10.0449 23.1377ZM7.24414 20.8125H7.25195H7.24414ZM1.99023 20.8125C1.46084 20.8109 0.953854 20.5995 0.580078 20.2246C0.206302 19.8497 -0.00390863 19.3419 -0.00390625 18.8125V2.8125C-0.00390863 2.2831 0.206302 1.77529 0.580078 1.40039C0.953854 1.02549 1.46084 0.814088 1.99023 0.8125H13C13.5304 0.8125 14.039 1.02336 14.4141 1.39844C14.7891 1.77351 15 2.28207 15 2.8125V9.43945C13.9885 9.25112 12.9496 9.2692 11.9453 9.49316C11.8805 9.29419 11.7534 9.12092 11.584 8.99805C11.4146 8.87517 11.2112 8.80941 11.002 8.80957H4.00195C3.73674 8.80957 3.48246 8.915 3.29492 9.10254C3.10739 9.29008 3.00195 9.54435 3.00195 9.80957C3.00195 10.0748 3.10739 10.3291 3.29492 10.5166C3.48246 10.7041 3.73674 10.8096 4.00195 10.8096H9.10156C8.18349 11.4975 7.43607 12.3866 6.91602 13.4092C6.83787 13.232 6.7106 13.081 6.54883 12.9746C6.38705 12.8682 6.19754 12.8112 6.00391 12.8096H4.00391C3.73869 12.8096 3.48441 12.915 3.29688 13.1025C3.10934 13.2901 3.00391 13.5444 3.00391 13.8096C3.00391 14.0748 3.10934 14.3291 3.29688 14.5166C3.48441 14.7041 3.73869 14.8096 4.00391 14.8096H6.00391C6.1377 14.809 6.26968 14.7814 6.39258 14.7285C6.19686 15.4044 6.09885 16.1049 6.10156 16.8086C6.10099 18.2233 6.49928 19.6095 7.25 20.8086L1.99023 20.8125ZM2.99023 5.8125C2.99023 5.94433 3.01773 6.07457 3.06836 6.19629C3.11899 6.31801 3.19166 6.42855 3.28516 6.52148C3.37865 6.61442 3.49126 6.68838 3.61328 6.73828C3.7353 6.78818 3.86427 6.81329 3.99609 6.8125H10.9961C11.2613 6.8125 11.5175 6.70707 11.7051 6.51953C11.8926 6.332 11.9961 6.07772 11.9961 5.8125C11.9961 5.54728 11.8926 5.293 11.7051 5.10547C11.5175 4.91793 11.2613 4.8125 10.9961 4.8125H3.99609C3.7314 4.81329 3.4779 4.91899 3.29102 5.10645C3.10413 5.2939 3 5.5478 3 5.8125H2.99023ZM8.16992 17.5127C8.1427 17.5003 8.11747 17.4824 8.09766 17.46C8.07784 17.4376 8.06366 17.4113 8.05469 17.3828L8.03516 17.332C7.89515 16.077 8.18377 14.8117 8.85352 13.7412C9.51355 12.671 10.5326 11.8706 11.7285 11.4824C12.3926 11.2562 13.0943 11.159 13.7949 11.1963C14.4978 11.2296 15.1883 11.3951 15.8301 11.6836L16.4121 10.5029C16.4378 10.4477 16.4741 10.398 16.5195 10.3574C16.5649 10.3168 16.618 10.2859 16.6758 10.2666C16.7324 10.2464 16.7936 10.2377 16.8535 10.2422C16.9135 10.2467 16.9705 10.2646 17.0234 10.293C17.0789 10.3175 17.129 10.3527 17.1699 10.3975C17.2109 10.4422 17.2422 10.4953 17.2617 10.5527L18.3125 13.6025C18.3324 13.6603 18.3406 13.7213 18.3359 13.7822C18.3313 13.8431 18.3136 13.902 18.2852 13.9561C18.2607 14.0109 18.2265 14.0606 18.1816 14.1006C18.1368 14.1406 18.0827 14.1704 18.0254 14.1885L14.9766 15.2393C14.919 15.259 14.8576 15.2674 14.7969 15.2637C14.7361 15.2599 14.6777 15.2445 14.623 15.2178C14.5141 15.1643 14.4302 15.0698 14.3906 14.9551C14.3511 14.8404 14.3593 14.7147 14.4121 14.6055L15.0293 13.3398C14.5303 13.1181 13.9873 13.01 13.4414 13.0234C12.8955 13.0369 12.3605 13.1709 11.873 13.417C11.3855 13.663 10.9581 14.0151 10.623 14.4463C10.288 14.8775 10.0536 15.377 9.93555 15.9102C9.88968 16.2157 9.85979 16.5234 9.8457 16.832C9.85118 16.8805 9.83914 16.9298 9.8125 16.9707C9.78586 17.0116 9.74579 17.0421 9.69922 17.0566L8.34375 17.5254C8.32116 17.5328 8.29721 17.5363 8.27344 17.5361C8.23883 17.5349 8.20521 17.5273 8.17383 17.5127H8.16992Z" />
        </SvgIcon>
    );
}

const LabelData = (props) => {
    const classes = useStyles();
    return (
        <Grid container className={classes.tabs} spacing={1}>
            <Grid item>
                <props.icon className={classes.icon} />
            </Grid>
            <Grid item>
                <span> {props.name} </span>
            </Grid>
        </Grid>
    );
}

const LateralMenu = (props) => {
    const dispatch = useDispatch()

    const { current_path } = props.homeReducer;
    const classes = useStyles();
    const reseteoCF = ()=>{
        localStorage.removeItem('irHome')
        dispatch(stepCircuit(0));
        dispatch(resetCF())
        dispatch(cleanFiles())
    }

    return (
        <>
            <Tabs
                value={current_path}
                TabIndicatorProps={{ style: { background: 'none' } }}
                orientation="vertical"
                variant="fullWidth"
                centered="false"
                aria-selected="false"
            >
                    {props.userDigitalWare?
                    <>
                      <Tab
                    value="/home/CircuitoFirmas"
                    className={'verticalTabsItems'}
                    component={Link}
                    onClick={reseteoCF}
                    to="/home/CircuitoFirmas"
                    label={
                        <LabelData
                            name="Mis circuitos de firmas"
                            icon={circuitoFirmas}
                        />
                
                    }
                />
                    </>
                :
                <>
                <Tab
                    value="/home/ConsultSignedDocument"
                    className={'verticalTabsItems'}
                    onClick={reseteoCF}
                    component={Link}
                    to="/home/ConsultSignedDocument"
                    label={
                        <LabelData
                            name="Mis documentos"
                            icon={docsIcon}
                        />
                    }
                />
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/firmar"
                    className={'verticalTabsItems'}
                    onClick={reseteoCF}
                    component={Link} to="/home/firmar"
                    label={
                        <LabelData
                            name="Firmar documentos"
                            icon={plumaIcon}
                        />
                    }
                />
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/cades"
                    className={'verticalTabsItems'}
                    onClick={reseteoCF}
                    component={Link} to="/home/cades"
                    label={
                        <LabelData
                            name="Firma Cades"
                            icon={plumaIcon}
                        />
                    }
                />
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/validate"
                    onClick={reseteoCF}
                    className={'verticalTabsItems'}
                    component={Link} to="/home/validate"
                    label={
                        <LabelData
                            name="Verificar documentos"
                            icon={checkIcon}
                        />
                    }
                />
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/Encrypt"
                    className={'verticalTabsItems'}
                    component={Link}
                    onClick={reseteoCF}
                    to="/home/Encrypt"
                    label={
                        <LabelData
                            name="Cifrar archivos"
                            icon={iconEncrypt}
                        />
                    }
                />
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/Decrypt"
                    className={'verticalTabsItems'}
                    component={Link}
                    onClick={reseteoCF}
                    to="/home/Decrypt"
                    label={
                        <LabelData
                            name="Descifrar archivos"
                            icon={iconDecrypt}
                        />
                
                    }
                />
                {/* ------------------------------------------------------------------------- */}
                <Divider className={classes.divider} variant="middle" />
                <Tab
                    value="/home/CircuitoFirmas"
                    className={'verticalTabsItems'}
                    component={Link}
                    onClick={reseteoCF}
                    to="/home/CircuitoFirmas"
                    label={
                        <LabelData
                            name="Mis circuitos de firmas"
                            icon={circuitoFirmas}
                        />
                
                    }
                />
                
                </>    
                }
               <br></br>
                <div className={classes.text}>Versión 1.21.1</div>
                <br></br>
                <div ><img src={LogoGSE} className={classes.logo} /></div> 
                </Tabs>
        </> 
    );

}


const mapStateToProps = (state) => ({
    homeReducer: state.home
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(LateralMenu);